import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { liveQuery } from 'dexie';
import { onboardingDb } from '../db/onboarding-db';
import type { UploadRecord } from '../models/upload-record.model';
import { UploadStatus } from '../models/upload-record.model';

@Injectable({ providedIn: 'root' })
export class UploadQueueService {
  async bulkAdd(records: UploadRecord[]): Promise<void> {
    await onboardingDb.uploadRecords.bulkAdd(records);
  }

  async patch(fileId: string, changes: Partial<UploadRecord>): Promise<void> {
    const rec = await onboardingDb.uploadRecords.get(fileId);
    if (!rec) return;
    await onboardingDb.uploadRecords.update(fileId, {
      ...changes,
      updatedAt: Date.now(),
    });
  }

  async setStatus(
    fileId: string,
    status: UploadStatus,
    extra?: Partial<UploadRecord>
  ): Promise<void> {
    await this.patch(fileId, { status, ...extra });
  }

  async getByStatus(status: UploadStatus): Promise<UploadRecord[]> {
    return onboardingDb.uploadRecords.where('status').equals(status).toArray();
  }

  async getRecord(fileId: string): Promise<UploadRecord | undefined> {
    return onboardingDb.uploadRecords.get(fileId);
  }

  async getAll(): Promise<UploadRecord[]> {
    return onboardingDb.uploadRecords.toArray();
  }

  watchAll(): Observable<UploadRecord[]> {
    return new Observable((subscriber) => {
      const sub = liveQuery(() => onboardingDb.uploadRecords.toArray()).subscribe(
        (records) => subscriber.next(records)
      );
      return () => sub.unsubscribe();
    });
  }

  async clearCompleted(): Promise<void> {
    await onboardingDb.uploadRecords
      .where('status')
      .equals(UploadStatus.UPLOADED)
      .delete();
  }
}
